import {Fragment} from 'react';

import BackStep from '../General/BackStep/BackStep';
import ProgressBar from '../ProgressBar/ProgressBar';
import SignupHelp from '../SignupHelp/SignupHelp';
import UpdateAnswers from '../UpdateAnswers/UpdateAnswers';
import classes from './PibaNoCode.module.scss';


declare function Translate(key: string): string;
declare var _curLang: any;

const PibaNoCode = (props) => {
   
    const handlePibaClick = () => {
        switch (_curLang) {
            case "he":
                window.location.href = "https://www.gov.il/he/departments/bureaus?OfficeId=95b283ad-fc02-40e6-ac6f-8986acac6b86";
                break;
            case "en":
                window.location.href = "https://www.gov.il/en/departments/bureaus?OfficeId=95b283ad-fc02-40e6-ac6f-8986acac6b86";
                break;
            case "ru":
                window.location.href = "https://www.gov.il/ru/departments/bureaus?OfficeId=95b283ad-fc02-40e6-ac6f-8986acac6b86";
                break;
            case "ar":
                window.location.href = "https://www.gov.il/ar/departments/bureaus?OfficeId=95b283ad-fc02-40e6-ac6f-8986acac6b86";
                break;
        
            default:
                break;
        }
    };

    const servicePositionsClick = () => {
        switch (_curLang) {
            case "he":
                window.location.href = "https://www.gov.il/he/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "en":
                window.location.href = "https://www.gov.il/en/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "ru":
                window.location.href = "https://www.gov.il/ru/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
            case "ar":
                window.location.href = "https://www.gov.il/ar/departments/bureaus?OfficeId=81118354-e792-4e08-9057-f7ae5200cbf9";
                break;
        
            default:
                break;
        }        
    };

    const onBackStepHandler = () => {
        props.prevScreen(); 
    };

    const onUpdateAnswersClick = () => {
        props.firstScreen();
    };

    
    return(
        <Fragment>   
            <ProgressBar pbWidth="100%"/>                                           
            <div className={classes.container}>   
                <div>         
                    <BackStep prevStep = {onBackStepHandler} />
                
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_Bio_ID_No_Code_Title')}</div>            
                    <div className={`preRegText ${classes.desc}`}>                    
                        <span>{Translate('N_Login_Bio_ID_No_Code_Desc')}</span>&nbsp; 
                        <span className={classes.text_bold}>{Translate('N_Login_Bio_ID_No_Code_Desc_2')}</span>&nbsp;
                        <span>{Translate('N_Login_Bio_ID_No_Code_Desc_3')}</span> 
                        <span>                                    
                            <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                <div className="gov-tooltiptitle">{Translate('N_Login_What_Is_SC_Reader')}</div>
                                <div className={`gov-tooltiptext ${classes.tooltip_pos}`} tabIndex={0}>
                                    {Translate('N_Login_What_Is_SC_Reader_Tooltip')}
                                </div>
                            </a> 
                        </span>                       
                    </div>                            
                    <div className={classes.buttons_container}>
                        <button className={`${classes.btn_piba} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_piba_ltr : ''}`} id='btnPibaOffices' onClick={handlePibaClick}>
                            <span>{Translate('N_Generel_Piba_List')}</span>                     
                        </button>   
                        <button className={classes.btn_service_pos} id='btnServicePositions' onClick={servicePositionsClick}>
                            <span>{Translate('N_General_Service_Station_List')}</span>                     
                        </button>                 
                    </div> 

                    <UpdateAnswers  onLinkClick={onUpdateAnswersClick}/>     
                </div>
                <div className={classes.signup_help}>
                    <SignupHelp />
                </div>
            </div>  
        </Fragment>
    );
};
export default PibaNoCode;